import {
  type MarketDataPage,
  type ParamsOf,
  useBackend,
  type WealthVote,
} from '@/backend';

export const useCoinMarketData = (coin: string, type?: 'faq') =>
  useBackend('market-data:get:coin/{slug}/', {
    slug: coin,
    type,
  });

export const useCoinMarketDataOrdered = (coin: string, page: MarketDataPage) =>
  useBackend(
    'market-data:get:v2/coin/{slug}/',
    {
      page,
      slug: coin,
    },
    {
      swrOptions: {
        dedupingInterval: 1000 * 60,
      },
    },
  );

export const useVotes = (coin: string) =>
  useBackend('wealth:get:coin/{slug}/bullish-percentage/', {
    slug: coin,
  });

export const useVote = (coin: string, vote: WealthVote) =>
  useBackend('wealth:post:vote/', {
    coin,
    vote,
  });

export const useCoinTimeMachine = (
  params: ParamsOf<'wealth:post:crypto-profit/'>,
) => useBackend('wealth:post:crypto-profit/', params);
